export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12068.4cf50b16.jpg";